import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ph-label',
  templateUrl: './ph-label.component.html',
  styleUrls: ['./ph-label.component.scss'],
})
export class PhLabelComponent {
  @Input() color: string;

  constructor() {}
}
